import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=e440b5bc&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=e440b5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e440b5bc",
  null
  
)

export default component.exports